import { DetailedHTMLProps, AnchorHTMLAttributes } from 'react';

export function DiscordLink({
    className,
    ...props
}: DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) {
    return (
        <a
            {...props}
            href='/api/connections/discord'
            className={
                'my-1 inline-block min-h-9 w-full round:rounded-lg border border-button-primary-border bg-button-primary/80 px-4 py-1.5 text-center text-white fast-spatial-transition hover:border-blue-300 hover:bg-button-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/25 round:active:rounded-md' +
                (className ? ' ' + className : '')
            }
        />
    );
}
